module.exports = __webpack_public_path__ + "static/media/IMG_8712.4e904251.JPG";